import React, { useEffect, useCallback } from 'react';
import { Redirect, withRouter, RouteComponentProps } from 'react-router-dom';
import LoginForm from '../LoginSupport/LoginForm';
import { Entry } from '../../../config';

export interface ILoginFields {
  staffUserName: string;
  staffPassword: string;
  msal_token?: any;
}

interface ILoginProperties extends RouteComponentProps {
  loggedIn: boolean;
  isAdmin?: boolean;
  isLoading: boolean;
  error: string;
  login(fields: ILoginFields): void;
}

const Login: React.FC<ILoginProperties> = (props) => {
  const { loggedIn, isAdmin, isLoading, error, login, history, location } = props;

  useEffect(
    () => {
      document.title = 'MomentumPro';
    },
    []
  );

  const handleSubmit = useCallback(
    (fields: ILoginFields) => {
      login(fields);
    },
    [login]
  );

  const getRedirectRoute = useCallback(
    (): { pathname: string; search?: string } => {
      if (history.location.state && (history.location.state as any).from) {
        const { pathname, search } = (history.location.state as any).from;

        return { pathname, search };
      }

      if (Entry && Entry === 'security-management') {
        return { pathname: '/security-policies' };
      }

      return { pathname: '/dashboard' };
    },
    [history.location.state]
  );

  const route = getRedirectRoute();

  if (
    (Entry && Entry === 'security-management' && loggedIn && isAdmin) ||
    ((!Entry || Entry !== 'security-management') && loggedIn)
  ) {
    return (
      <Redirect
        to={{
          ...route,
          state: { from: location },
        }}
      />
    );
  }

  return (
    <div style={{
      position: 'absolute',
      top: 'calc(50% - 209px)',
      left: 'calc(50% - 250px)',
      width: '500px',
      height: 'auto',
      backgroundColor: 'rgb(244, 244, 244)',
      overflow: 'hidden',
      boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '50px 0'
    }}>
      <div>
      <LoginForm
          isLoading={isLoading}
          onSubmit={handleSubmit}
          error={
            error ||
            ((Entry && Entry === 'security-management' && loggedIn && !isAdmin) &&
              'Please sign in as an administrator.')
          }
        />
      </div>
    </div>
  );
};

export default withRouter(Login);
